/** Stable identifiers for each request-setup table column. */
export const ConfigurationSetColumnKey = Object.freeze({
    Name: 'name',
    Warning: 'warning',
    Description: 'description',
    ApprovalProcess: 'approvalProcess',
    RequestType: 'requestType',
    RequestSubtype: 'requestSubtype',
    CreationHyperfind: 'creationHyperfind',
    ManagementHyperfind: 'managementHyperfind',
});

/** Smallest width (in %) a column can be shrunk to while resizing. */
export const MIN_COLUMN_WIDTH_PERCENT = 5;

/**
 * Single source of truth for the request-setup table columns, shared by the
 * header and the rows. `width` values are percentages and reflect the layout
 * currently in production. `sortKey` matches the field used by the sort handler.
 */
export const CONFIGURATION_SET_COLUMNS = [
    { key: ConfigurationSetColumnKey.Name, tKey: 'settings.name', sortKey: 'name', cellClassName: 'cstr-name', width: 15 },
    { key: ConfigurationSetColumnKey.Warning, tKey: 'settings.warning', sortKey: 'warnings', cellClassName: 'cstr-warning', width: 10 },
    { key: ConfigurationSetColumnKey.Description, tKey: 'settings.description', sortKey: 'description', cellClassName: 'cstr-description', width: 15 },
    { key: ConfigurationSetColumnKey.ApprovalProcess, tKey: 'settings.approvalProcess', sortKey: 'autoApproval', cellClassName: 'cstr-approval-process', width: 10 },
    { key: ConfigurationSetColumnKey.RequestType, tKey: 'settings.requestType', sortKey: 'actionType', cellClassName: 'cstr-request-type', width: 10 },
    { key: ConfigurationSetColumnKey.RequestSubtype, tKey: 'settings.requestSubtype', sortKey: 'requestSubtype', cellClassName: 'cstr-request-subtype', width: 10 },
    { key: ConfigurationSetColumnKey.CreationHyperfind, tKey: 'settings.creationHyperfind', sortKey: 'creationHyperfindId', cellClassName: 'cstr-creation-hf', width: 15 },
    { key: ConfigurationSetColumnKey.ManagementHyperfind, tKey: 'settings.managementHyperfind', sortKey: 'managementHyperfindId', cellClassName: 'cstr-management-hf', width: 15 },
];
